interface String {
    format(...replacements: (string|number|null)[]): string;
    f(...replacements: (string|number|null)[]): string;
}

if(typeof String.prototype.format !== 'function') {
    String.prototype.format = String.prototype.f = function(){
        return this.replace(/\{(\d+)\}/g, (m,n)=>arguments[n]);
    };
}